import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingComponent } from './landing.component';
import { SharedModule } from '../shared/shared.module';
import { LoginPageComponent } from './login-page/login-page.component';
import { RecoverPassPageComponent } from './recover-pass-page/recover-pass-page.component';
import { RouterModule } from '@angular/router';
import { CreateMerchantComponent } from './create-merchant/create-merchant.component';
import { TermsComponent } from './terms/terms.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { LandingRoutingModule } from './landing-routing.module';
import { SharedWithClientModule } from '../shared-with-client/shared-with-client.module';
import { PricingComponent } from './pricing/pricing.component';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TransferState } from '@angular/platform-browser';
import { TranslateBrowserLoader } from '../core/translate-browser.service';
import { FaqsComponent } from './faqs/faqs.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SetPasswordPageComponent } from './set-password-page/set-password-page.component';
import { NotFoundPageComponent } from './not-found-page/not-found-page.component';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { UnsubscribePageComponent } from './unsubscribe-page/unsubscribe-page.component';
import { CookiesPolicyComponent } from './cookies-policy/cookies-policy.component';
import { BookingPageComponent } from './booking-page/booking-page.component';
import { CalendarPageComponent } from './calendar-page/calendar-page.component';
import { SignupComponent } from './signup/signup.component';
import { NgxIntlTelInputModule } from 'untold-ngx-intl-tel-input';
import { MbwayRenewComponent } from './mbway-renew/mbway-renew.component';
import { MagicLinkPageComponent } from './magic-link-page/magic-link-page.component';


export function createTranslateLoader(http: HttpClient, transferState: TransferState) {
  // return new TranslateHttpLoader(http, './assets/i18n-lang/', '.json');
  return new TranslateBrowserLoader(transferState, http);
}

@NgModule({
  imports: [
    CommonModule,
    LandingRoutingModule,
    SharedModule,
    SharedWithClientModule,
    ReactiveFormsModule,
    RouterModule,
    NgxPageScrollCoreModule.forRoot({duration: 400}),
    NgxPageScrollModule,
    FormsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient, TransferState]
      }
    }),
    AccordionModule.forRoot(),
    BsDropdownModule.forRoot(),
    NgxIntlTelInputModule
  ],
  declarations: [
    LandingComponent,
    LoginPageComponent,
    RecoverPassPageComponent,
    CreateMerchantComponent,
    TermsComponent,
    PrivacyComponent,
    CookiesPolicyComponent,
    PricingComponent,
    FaqsComponent,
    SetPasswordPageComponent,
    NotFoundPageComponent,
    UnsubscribePageComponent,
    BookingPageComponent,
    CalendarPageComponent,
    SignupComponent,
    MbwayRenewComponent,
    MagicLinkPageComponent
  ]
})
export class LandingModule { }
